import classNames from 'classnames';
import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import IconButton from '@alltrails/denali/components/IconButton';
import ChevronSm from '@alltrails/denali/icons/ChevronSm';
import styles from './styles/styles.module.scss';

type PopupCarouselControlsProps = {
  className?: string;
  index: number;
  onIndexChange: (newIndex: number) => void;
  total: number;
};

const PopupCarouselControls = ({ className, index, onIndexChange, total }: PopupCarouselControlsProps) => {
  const intl = useIntl();
  return (
    <div className={classNames(styles.container, className)}>
      <IconButton
        className={styles.iconButton}
        icon={{ Component: ChevronSm, orientation: 'left' }}
        title={intl.formatMessage({ defaultMessage: 'Previous' })}
        onClick={e => {
          e.stopPropagation();
          onIndexChange(index === 0 ? total - 1 : index - 1);
        }}
        size="md"
        variant="ghost"
      />
      <div className={styles.text}>
        <FormattedMessage
          defaultMessage="{count}<span>of</span>{total}"
          values={{ span: (text: ReactNode) => <span>{text}</span>, count: index + 1, total }}
        />
      </div>
      <IconButton
        className={styles.iconButton}
        icon={{ Component: ChevronSm, orientation: 'right' }}
        title={intl.formatMessage({ defaultMessage: 'Next' })}
        onClick={e => {
          e.stopPropagation();
          onIndexChange((index + 1) % total);
        }}
        size="md"
        variant="ghost"
      />
    </div>
  );
};

export default PopupCarouselControls;
